/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PartnerClientCompanyEvent'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PartnerClientCompanyEvent'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PartnerClientCompanyReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PartnerClientCompanyEvent);
  }
}(this, function(ApiClient, PartnerClientCompanyEvent) {
  'use strict';




  /**
   * The PartnerClientCompanyReport model module.
   * @module model/PartnerClientCompanyReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PartnerClientCompanyReport</code>.
   * @alias module:model/PartnerClientCompanyReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>PartnerClientCompanyReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PartnerClientCompanyReport} obj Optional instance to populate.
   * @return {module:model/PartnerClientCompanyReport} The populated <code>PartnerClientCompanyReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Accessible')) {
        obj['Accessible'] = ApiClient.convertToType(data['Accessible'], 'Boolean');
      }
      if (data.hasOwnProperty('UserCount')) {
        obj['UserCount'] = ApiClient.convertToType(data['UserCount'], 'Integer');
      }
      if (data.hasOwnProperty('FixedMonthlyServicePrice')) {
        obj['FixedMonthlyServicePrice'] = ApiClient.convertToType(data['FixedMonthlyServicePrice'], 'Number');
      }
      if (data.hasOwnProperty('CustomerSatisfactionScore')) {
        obj['CustomerSatisfactionScore'] = ApiClient.convertToType(data['CustomerSatisfactionScore'], 'Integer');
      }
      if (data.hasOwnProperty('UserActivenessScore')) {
        obj['UserActivenessScore'] = ApiClient.convertToType(data['UserActivenessScore'], 'Integer');
      }
      if (data.hasOwnProperty('Events')) {
        obj['Events'] = ApiClient.convertToType(data['Events'], [PartnerClientCompanyEvent]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('SupportLevelID')) {
        obj['SupportLevelID'] = ApiClient.convertToType(data['SupportLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('PerformanceManagementAlertEvaluationInterval')) {
        obj['PerformanceManagementAlertEvaluationInterval'] = ApiClient.convertToType(data['PerformanceManagementAlertEvaluationInterval'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} Accessible
   * @default false
   */
  exports.prototype['Accessible'] = false;
  /**
   * @member {Integer} UserCount
   * @default 0
   */
  exports.prototype['UserCount'] = 0;
  /**
   * @member {Number} FixedMonthlyServicePrice
   * @default 0.0
   */
  exports.prototype['FixedMonthlyServicePrice'] = 0.0;
  /**
   * @member {Integer} CustomerSatisfactionScore
   */
  exports.prototype['CustomerSatisfactionScore'] = undefined;
  /**
   * @member {Integer} UserActivenessScore
   * @default 0
   */
  exports.prototype['UserActivenessScore'] = 0;
  /**
   * @member {Array.<module:model/PartnerClientCompanyEvent>} Events
   */
  exports.prototype['Events'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} SupportLevelID
   * @default 0
   */
  exports.prototype['SupportLevelID'] = 0;
  /**
   * @member {Integer} PerformanceManagementAlertEvaluationInterval
   */
  exports.prototype['PerformanceManagementAlertEvaluationInterval'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


